import './App.css';

import React, { useEffect } from 'react';

import Navbar from './components/Navbar';

import useMobile from './hooks/useMobile';

import SanMarino1 from './img/sanmarino/san_marino_1.jpg';
import SanMarino2 from './img/sanmarino/san_marino_2.jpg';
import SanMarino3 from './img/sanmarino/san_marino_3.jpg';
import SanMarino4 from './img/sanmarino/san_marino_4.jpg';

import Fellini1 from './img/fellini/fellini_1.jpg';
import Fellini2 from './img/fellini/fellini_2.jpg';
import Fellini3 from './img/fellini/fellini_3.jpg';
import Fellini4 from './img/fellini/fellini_4.jpg';

import Santarcangelo1 from './img/santarcangelo/santarcangelo_1.jpg';
import Santarcangelo2 from './img/santarcangelo/santarcangelo_2.jpg';
import Santarcangelo3 from './img/santarcangelo/santarcangelo_3.jpg';
import Santarcangelo4 from './img/santarcangelo/santarcangelo_4.jpg';

import Bolonia1 from './img/bolonia/bolonia_1.jpg';
import Bolonia2 from './img/bolonia/bolonia_2.jpg';
import Bolonia3 from './img/bolonia/bolonia_3.jpg';
import Bolonia4 from './img/bolonia/bolonia_4.jpg';

import Rimini_noc1 from './img/rimini_noc/rimini_noc_1.jpg';
import Rimini_noc2 from './img/rimini_noc/rimini_noc_2.jpg';
import Rimini_noc3 from './img/rimini_noc/rimini_noc_3.jpg';
import Rimini_noc4 from './img/rimini_noc/rimini_noc_4.jpg';

import Florencja1 from './img/florencja/florencja_1.jpg';
import Florencja2 from './img/florencja/florencja_2.jpg';
import Florencja3 from './img/florencja/florencja_3.jpg';
import Florencja4 from './img/florencja/florencja_4.jpg';

function Gallery(props: { images: { src: string, alt: string }[] }) {
    return (
        <div className='Gallery'>
            {props.images.map((image) => {
                return (
                    <div className='Gallery__image'>
                        <a href={image.src} target='_blank'><img src={image.src} alt={image.alt} width={'100%'} /></a>
                    </div>
                )
            })}
        </div>
    )
}

function Wycieczka(props: { title: string, text: string, images: { src: string, alt: string }[] }) {
    return (
        <div className='Wycieczka'>
            <div className='Wycieczka__title'>
                {props.title}
            </div>
            <Gallery images={props.images} />
            <div className='Wycieczka__text'>
                {props.text}
            </div>
            <hr></hr>
        </div>
    )
}

export default function Wycieczki() {
    useEffect(() => {
        window.scrollTo({top: 0});
    }, [])
    const sanmarino_gallery = [
        {
            src: SanMarino4,
            alt: 'San Marino 4'
        },
        {
            src: SanMarino3,
            alt: 'San Marino 3'
        },
        {
            src: SanMarino1,
            alt: 'San Marino 1'
        },
        {
            src: SanMarino2,
            alt: 'San Marino 2'
        },
    ]

    const fellini_gallery = [
        {
            src: Fellini1,
            alt: 'Fellini 1'
        },
        {
            src: Fellini3,
            alt: 'Fellini 3'
        },
        {
            src: Fellini2,
            alt: 'Fellini 2'
        },
        {
            src: Fellini4,
            alt: 'Fellini 4'
        },
    ]

    const santarcangelo_gallery = [
        {
            src: Santarcangelo4,
            alt: 'Santarcangelo 4'
        },
        {
            src: Santarcangelo1,
            alt: 'Santarcangelo 1'
        },
        {
            src: Santarcangelo3,
            alt: 'Santarcangelo 3'
        },
        {
            src: Santarcangelo2,
            alt: 'Santarcangelo 2'
        },
    ]

    const bolonia_gallery = [
        {
            src: Bolonia1,
            alt: 'Bolonia 1'
        },
        {
            src: Bolonia2,
            alt: 'Bolonia 2'
        },
        {
            src: Bolonia3,
            alt: 'Bolonia 3'
        },
        {
            src: Bolonia4,
            alt: 'Bolonia 4'
        },
    ]

    const rimini_noc_gallery = [
        {
            src: Rimini_noc1,
            alt: 'Rimini noc 1'
        },
        {
            src: Rimini_noc2,
            alt: 'Rimini noc 2'
        },
        {
            src: Rimini_noc3,
            alt: 'Rimini noc 3'
        },
        {
            src: Rimini_noc4,
            alt: 'Rimini noc 4'
        },
    ]

    const florencja_gallery = [
        {
            src: Florencja3,
            alt: 'Florencja 3'
        },
        {
            src: Florencja2,
            alt: 'Florencja 2'
        },
        {
            src: Florencja4,
            alt: 'Florencja 4'
        },
        {
            src: Florencja1,
            alt: 'Florencja 1'
        },
    ]

    return (
        <>
        <Navbar />
        <div className='App__container'>
            <div className='App'>
                <div className='App__content'>
                    <div className='App__content__title'>
                        Wycieczki i czas wolny
                    </div>
                    <div className='App__content__text'>
                        Uczniowie mieli możliwość spędzenia czasu wolny na wiele ciekawych sposobów.<br></br>Jednym z nich były wycieczki do przeróżnych miejsc.
                    </div>
                    <Wycieczka
                        title='Florencja'
                        images={florencja_gallery}
                        text='Byliśmy w kolebce humanizmu. To tu, we Florencji żyli i tworzyli Michał Anioł, Leonardo da Vinci, Dante, Sandro Botticelli i inni renesansowi artyści. Miasto zachwyciło nas wspaniałą architekturą. Spacerowaliśmy po bulwarach rzeki Arno, przeszliśmy przez Ponte Vecchio, zobaczyliśmy słynną Katedrę (Duomo) Santa Maria del Fiore z niemniej znaną kopułą zaprojektowaną przez Filippo Brunelleschiego, a niektórzy nawet weszli do środka świątyni, budowanej około 600 lat. Dotarliśmy też do Kościoła św. Trójcy (Santa Trynita), w którym znajdują się freski włoskich artystów pochodzące z XV wieku. Italia to kolebka światowej mody, więc także w zabytkowej części miasta znajdują się salony słynnych projektantów, Armani czy Gucci. Przed jednym z nich zrobiliśmy pamiątkowe zdjęcie. Wędrówkę po urokliwych, choć zatłoczonych uliczkach Florencji zakończyliśmy przez pięknym kościołem Santa Maria Novella. Zobaczyliśmy wiele i jednocześnie niewiele, bo Florencja to miejsce, gdzie zgromadzono ponad 30 procent wszystkich światowych dzieł sztuki, ale przecież tu jeszcze wrócimy.'
                    />
                    <Wycieczka
                        title='Rimini nocą'
                        images={rimini_noc_gallery}
                        text='Rimini nocą jest jeszcze ciekawsze niż w dzień, a może tylko inne, bardziej nastrojowe. Wieczorem życie z okolic plaży przenosi się do Borgo San Giuliano. Kawiarenki pełne są biesiadujących ludzi, Most Tuberiusza, Marecchia są pięknie oświetlone. W jeden z ostatnich, kwietniowych, ciepłych wieczorów oglądaliśmy Rimini, a szczególnie Borgo San Giuliano, nocą.'
                    />
                    <Wycieczka
                        title='Bolonia'
                        images={bolonia_gallery}
                        text='W sobotę wybraliśmy się pociągiem do Bolonii. To duży ośrodek naukowy i tętniące życiem miasto. Zwiedzaliśmy je, a naszymi przewodnikami byli: Gabrysia, Jola i Mariusz, którzy przygotowali trasę wycieczki. Odwiedziliśmy Pinacotekę, z Poliptykiem Giotta i obrazem Rafaella, W Museo di Palazzio Poggi należącym do Uniwersytetu Bolońskiego podziwialiśmy osiągnięcia geografów, przyrodników i medyków. Jedna z sal prezentuje historię tej najstarszej uczelni i pokazuje współczesne osiągnięcia.'
                    />
                    <Wycieczka 
                        title='Santarcangelo'
                        images={santarcangelo_gallery}
                        text='W tym tygodniu po pracy niektórzy wybrali się również do małego, cichego Santarcangelo. Położona na wzgórzu starówka ze swoimi wąskimi uliczkami, zabytkowym kościołem i kamieniczkami pozwala poczuć klimat włoskiego miasteczka. Przy domach pną się wisterie lub kwitną róże. Spacerując, dotarliśmy do kościoła św. Archaniola, w którym znajduje się dzieło malarza Guido Cagnacciego, urodzonego w Santarcangelo i kaplica ze szczątkami błogosławionego Simone. Jednak najbardziej zaskakujące okazało się muzeum guzików. Wśród wielu pięknych i markowych znalazły się też te związane z naszą historią i naszymi ziemiami.' 
                    />
                    <Wycieczka 
                        title='Muzeum Felliniego'
                        images={fellini_gallery}
                        text='25 kwietnia, w święto "Festa della Liberazione" (Święto Wyzwolenia), poszliśmy do Castello Sismondo, do muzeum F. Felliniego. Ten wybitny reżyser włoski, obsypany nagrodami,  pochodził  z Rimini tu też został pochowany. W muzeum można poczuć klimat filmów Felliniego i wejść w świat wyobraźni  tego wyjątkowego artysty. Pamiątki związane z reżyserem można znaleźć również w kinie Fulgor, w którym młody Fellini zobaczył swój pierwszy film. To miejsce też odwiedziliśmy i przespacerowaliśmy się przez Plac Marzeń - przestrzeń między zamkiem i kinem. Podziękowaliśmy za ciekawe doznania, wpisując się do księgi pamiątkowej.'
                    />
                    <Wycieczka
                        title='Wycieczka do San Marino'
                        images={sanmarino_gallery}
                        text='W ramach poznawania kultury wybraliśmy się do San Marino. Wcześniej kilkoro z nas przygotowało plan wycieczki i przewodnik po tym państwie. Dzień wcześniej Hubert i Piotr przedstawili nam podstawowe informacje na temat San Marino, jego historii i czasów współczesnych. Jeszcze przed wyjazdem zwróciliśmy uwagę na umiłowanie wolności mieszkańców tego państwa. W trakcie zwiedzając starego miasta, szukaliśmy miejsc, o których mówili koledzy i odkrywaliśmy nowe. Zachwyciła nas topografia tego miasta zbudowanego na skale, podziwialiśmy  budowle, pomniki, a niektórzy dotarli nawet do twierdzy La Rocca o Guaita i zwiedzili ten obiekt powstały w XI wieku. Kupując bilet do twierdzy,  nabyliśmy też możliwość wejścia do siedziby władz San Marino, Palazzo Pubblico.  Zachwyca szczególnie  sala parlamentu, w której ściany zdobią piękne malowidła ścienne. Sala jest użytkowana, na stolikach stoją laptopy, jest kilka telewizorów, zamontowano mikrofony. Odbywają się tak obrady władz, a kiedy władze nie obradują, turyści mogą salę zwiedzać.  San Marino umiejętnie łączy piękną historię ze współczesnością. W mieście wiele jest współczesnych rzeźb i pomników upamiętniających ważne i tragiczne wydarzenia, jak te z czasów II wojny światowej czy tragedię dzieci z Biesłana. Jedną ze współczesnych atrakcji w dniu naszej wycieczki była impreza Steam party 2023 oraz wystawa Lego.'
                    />
                </div>
            </div>
            <div className='App__background'></div>
        </div>
        </>
    )
}